import { IconStorage } from "@app/shared/icons/interfaces";

export const switchHorizontalV1: IconStorage = {
  svgCode: () => ([
    "M20 17H4M4 17L8 13M4 17L8 21M4 7H20M20 7L16 3M20 7L16 11",
  ]),
};

export const switchVerticalV1: IconStorage = {
  svgCode: () => ([
    "M17 4V20M17 20L13 16M17 20L21 16M7 20V4M7 4L3 8M7 4L11 8",
  ]),
};